"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MagicPen = void 0;
var _jsxRuntime = require("react/jsx-runtime");
let uniqueIdCounter = 0;
const MagicPen = () => {
  const uniqueId = `uniqueGradient${uniqueIdCounter++}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M16.7586 1.0022C16.753 1.01705 16.7325 1.09872 16.7102 1.1841C16.6395 1.46437 16.487 1.77063 16.2991 2.01563C16.0926 2.28105 15.7411 2.55947 15.4193 2.70981C15.2705 2.78034 14.971 2.87686 14.9022 2.87686C14.8333 2.87686 14.8501 2.91027 14.9263 2.92326C15.1923 2.96781 15.5904 3.15156 15.8545 3.35016C16.1429 3.56547 16.4368 3.92741 16.5763 4.23552C16.6414 4.38029 16.7456 4.69769 16.7456 4.75151C16.7456 4.82204 16.779 4.80534 16.7921 4.72924C16.8293 4.51764 16.9818 4.15385 17.125 3.93854C17.4543 3.44482 17.923 3.10887 18.5034 2.94925C18.6057 2.9214 18.6764 2.89542 18.6615 2.88985C18.6466 2.88428 18.5648 2.86387 18.4811 2.84159C17.6738 2.63185 17.0227 1.97108 16.8107 1.14141C16.7865 1.04861 16.7642 0.987355 16.7586 1.0022Z",
      fill: `url(#${uniqueId}_paint0_linear_15_7628)`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M17.6651 6.0388C17.5993 6.24745 17.4701 6.46314 17.3009 6.646C17.0941 6.87107 16.8803 7.00001 16.4762 7.14536C16.4433 7.15708 16.4715 7.17584 16.5937 7.2157C16.8357 7.29306 17.0636 7.43842 17.2609 7.63769C17.463 7.844 17.5711 8.01514 17.6627 8.26834C17.7003 8.37384 17.7309 8.43479 17.7403 8.41369C17.7473 8.39494 17.7778 8.3082 17.8107 8.2238C17.9776 7.77132 18.3746 7.38684 18.8539 7.21804C18.9338 7.18756 18.9996 7.16177 18.9996 7.15943C18.9996 7.15708 18.9338 7.1313 18.8539 7.10082C18.3676 6.92968 17.9611 6.52878 17.799 6.06927C17.7708 5.98487 17.7403 5.90985 17.7309 5.89813C17.7238 5.88875 17.6933 5.95205 17.6651 6.0388Z",
      fill: `url(#${uniqueId}_paint1_linear_15_7628)`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15.2516 8.58106C15.1535 8.78139 15.0088 8.93292 14.8102 9.04336L14.6557 9.13068L14.7979 9.20259C14.9745 9.29505 15.1608 9.49025 15.2614 9.68801L15.3374 9.83954L15.4183 9.68287C15.5164 9.48768 15.6758 9.32074 15.8622 9.21543C15.9406 9.17177 16.0068 9.13068 16.0068 9.12811C16.0068 9.12297 15.9455 9.08702 15.8695 9.04849C15.693 8.9586 15.4992 8.75314 15.411 8.56565C15.3742 8.48603 15.3398 8.41925 15.3374 8.41925C15.3349 8.41925 15.2957 8.49117 15.2516 8.58106Z",
      fill: `url(#${uniqueId}_paint2_linear_15_7628)`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.6584 1.53242C12.532 1.7943 12.3456 1.99239 12.0897 2.13676L11.8906 2.25091L12.0739 2.34492C12.3014 2.46578 12.5415 2.72094 12.671 2.97946L12.769 3.17755L12.8732 2.97275C12.9996 2.71759 13.205 2.49936 13.4451 2.3617C13.5462 2.30463 13.6315 2.25091 13.6315 2.24755C13.6315 2.24084 13.5525 2.19383 13.4546 2.14347C13.2271 2.02596 12.9775 1.75737 12.8637 1.51228C12.8164 1.4082 12.7721 1.32091 12.769 1.32091C12.7658 1.32091 12.7153 1.41492 12.6584 1.53242Z",
      fill: `url(#${uniqueId}_paint3_linear_15_7628)`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.6572 3.77843C13.4674 3.86891 1.18551 16.3637 1.06838 16.5817C0.983571 16.7503 0.975493 17.0999 1.05627 17.3014C1.12897 17.4783 2.30829 18.7121 2.56677 18.8807C2.71217 18.9794 2.79294 19 2.98276 19C3.112 19 3.27759 18.9753 3.35029 18.9424C3.42703 18.9095 6.03204 16.2814 9.70732 12.5346C15.4383 6.69442 15.9351 6.17209 15.9795 6.00347C16.032 5.80194 16.0078 5.56339 15.9149 5.37832C15.8826 5.31251 15.5514 4.94236 15.1799 4.56398C14.465 3.82778 14.2913 3.70028 13.9803 3.70028C13.8915 3.70028 13.7461 3.7373 13.6572 3.77843ZM14.6831 5.07397C15.2526 5.65388 15.3374 5.7567 15.301 5.8225C15.2768 5.86774 14.99 6.17209 14.6589 6.50523L14.0611 7.11393L13.3624 6.40241L12.6637 5.69089L13.3099 5.04518C13.6694 4.69147 13.9723 4.39946 13.9884 4.39946C14.0086 4.39946 14.3196 4.70381 14.6831 5.07397ZM12.8899 6.90829L13.5765 7.60747L9.1944 12.0699L4.81233 16.5323L4.11766 15.8249L3.41895 15.1134L7.78891 10.6633C10.196 8.21206 12.171 6.20911 12.1831 6.20911C12.1952 6.20911 12.5143 6.52579 12.8899 6.90829ZM3.64108 16.3267L4.32768 17.0258L3.70167 17.6633C3.35837 18.0129 3.04738 18.3008 3.01507 18.3008C2.93834 18.3008 1.68228 17.0258 1.68228 16.9477C1.68228 16.8942 2.88179 15.6275 2.9343 15.6275C2.94642 15.6275 3.26548 15.9401 3.64108 16.3267Z",
      fill: "black"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.6572 3.77843C13.4674 3.86891 1.18551 16.3637 1.06838 16.5817C0.983571 16.7503 0.975493 17.0999 1.05627 17.3014C1.12897 17.4783 2.30829 18.7121 2.56677 18.8807C2.71217 18.9794 2.79294 19 2.98276 19C3.112 19 3.27759 18.9753 3.35029 18.9424C3.42703 18.9095 6.03204 16.2814 9.70732 12.5346C15.4383 6.69442 15.9351 6.17209 15.9795 6.00347C16.032 5.80194 16.0078 5.56339 15.9149 5.37832C15.8826 5.31251 15.5514 4.94236 15.1799 4.56398C14.465 3.82778 14.2913 3.70028 13.9803 3.70028C13.8915 3.70028 13.7461 3.7373 13.6572 3.77843ZM14.6831 5.07397C15.2526 5.65388 15.3374 5.7567 15.301 5.8225C15.2768 5.86774 14.99 6.17209 14.6589 6.50523L14.0611 7.11393L13.3624 6.40241L12.6637 5.69089L13.3099 5.04518C13.6694 4.69147 13.9723 4.39946 13.9884 4.39946C14.0086 4.39946 14.3196 4.70381 14.6831 5.07397ZM12.8899 6.90829L13.5765 7.60747L9.1944 12.0699L4.81233 16.5323L4.11766 15.8249L3.41895 15.1134L7.78891 10.6633C10.196 8.21206 12.171 6.20911 12.1831 6.20911C12.1952 6.20911 12.5143 6.52579 12.8899 6.90829ZM3.64108 16.3267L4.32768 17.0258L3.70167 17.6633C3.35837 18.0129 3.04738 18.3008 3.01507 18.3008C2.93834 18.3008 1.68228 17.0258 1.68228 16.9477C1.68228 16.8942 2.88179 15.6275 2.9343 15.6275C2.94642 15.6275 3.26548 15.9401 3.64108 16.3267Z",
      fill: `url(#${uniqueId}_paint4_linear_15_7628)`
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: `${uniqueId}_paint0_linear_15_7628`,
        x1: "16.7611",
        y1: "4.79633",
        x2: "16.7611",
        y2: "0.999988",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: `${uniqueId}_paint1_linear_15_7628`,
        x1: "17.7316",
        y1: "8.41785",
        x2: "17.7316",
        y2: "5.89721",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: `${uniqueId}_paint2_linear_15_7628`,
        x1: "15.3313",
        y1: "9.83954",
        x2: "15.3313",
        y2: "8.41925",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: `${uniqueId}_paint3_linear_15_7628`,
        x1: "12.7611",
        y1: "3.17755",
        x2: "12.7611",
        y2: "1.32091",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: `${uniqueId}_paint4_linear_15_7628`,
        x1: "8.50341",
        y1: "19",
        x2: "8.50341",
        y2: "3.70028",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      })]
    })]
  });
};
exports.MagicPen = MagicPen;